// Browser replacement for node's `querystring` module (webpack 2 polyfilled it,
// Vite doesn't ship node builtins to the client). Mirrors querystring.stringify:
// insertion order, arrays become repeated keys, null/undefined become `key=`.
const encodeValue = (value) => {
  if (value === undefined || value === null) return '';
  return encodeURIComponent(value);
};

export const stringify = (obj) => {
  const parts = [];
  Object.keys(obj || {}).forEach((key) => {
    const value = obj[key];
    const encodedKey = encodeURIComponent(key);
    if (Array.isArray(value)) {
      value.forEach((item) => parts.push(`${encodedKey}=${encodeValue(item)}`));
    } else {
      parts.push(`${encodedKey}=${encodeValue(value)}`);
    }
  });
  return parts.join('&');
};

export default { stringify };
